import React from 'react'

const MangaContainer = () => {
  return (
    <div>MangaContainer</div>
  )
}

export default MangaContainer